import React from 'react';

import { UseFieldArrayReplace } from 'react-hook-form';

import { Checkbox } from 'components/DesignSystem/Checkbox';
import classes from 'components/Settings/Components/RolesManagement/components/addRole.module.scss';
import { IPrivilege, IRoleForm } from 'components/Settings/Components/RolesManagement/rolesManagment.utils.type';

interface Props {
    replace: UseFieldArrayReplace<IRoleForm, 'privilegeList'>;
    id: string;
    watchFieldArray: IPrivilege[] | undefined;
}

export const CheckAll = ({ replace, watchFieldArray }: Props) => {
    const allChecked = Boolean(watchFieldArray?.every((item) => item.value));

    const handleCheckAllCheckbox = (): void => {
        watchFieldArray && replace(watchFieldArray.map((item) => ({ ...item, value: !allChecked })));
    };

    return (
        <label className={classes.selectAllContainer}>
            <Checkbox
                checked={allChecked}
                onChange={handleCheckAllCheckbox}
                label={'Select All'}
                labelPlacement={'end'}
            />
        </label>
    );
};
